export type FormFieldType = 'text' | 'email' | 'tel' | 'select' | 'textarea' | 'number' | 'date' | 'radio';

export type AppointmentType = 
  | 'product-consultation'
  | 'private-intro-class'
  | 'private-ownership'
  | 'boardroom-meeting'
  | 'builder-package-viewing';

export type EventType = 
  | 'public-intro-class'
  | 'public-ownership'
  | 'dealer-training'
  | 'ceu'
  | 'special-event';

export type SelectOption = {
  label: string;
  value: string;
};

export interface FormFieldOption extends SelectOption {}

import { ComponentType } from 'react';

export interface FormField {
  id: string;
  type: FormFieldType;
  label: string;
  required: boolean;
  translationKey: string;
  options?: FormFieldOption[];
  isClearable?: boolean;
  placeholder?: string;
  useGoogleAutocomplete?: boolean;
  component?: ComponentType<any>;
  validation?: {
    pattern?: string;
    min?: number;
    max?: number;
    minLength?: number;
    maxLength?: number;
  };
}

export interface FormFieldsConfig {
  [formType: string]: {
    fields: FormField[];
    layout: {
      rows: string[][];  // Array of arrays, each inner array represents field IDs in a row
    };
  };
}

// Common fields that are used across multiple forms
const TRANSLATION_NS = 'appointments';

export const commonFormFields: Record<string, FormField> = {
  firstName: {
    id: 'firstName',
    type: 'text',
    label: 'First Name',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.firstName`
  },
  lastName: {
    id: 'lastName',
    type: 'text',
    label: 'Last Name',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.lastName`
  },
  email: {
    id: 'email',
    type: 'email',
    label: 'Email',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.email`
  },
  phone: {
    id: 'phone',
    type: 'tel',
    label: 'Phone',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.phone`
  },
  company: {
    id: 'company',
    type: 'text',
    label: 'Company',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.company`
  },
  jobTitle: {
    id: 'jobTitle',
    type: 'text',
    label: 'Job Title',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.jobTitle`
  },
  preferredDate: {
    id: 'preferredDate',
    type: 'date',
    label: 'Preferred Date',
    required: true,
    translationKey: `${TRANSLATION_NS}:form.preferredDate`
  },
  notes: {
    id: 'notes',
    type: 'textarea',
    label: 'Additional Notes',
    required: false,
    translationKey: `${TRANSLATION_NS}:form.notes`
  }
};
